/**
 * This file contains the configuration for DataDog RUM, which we use for
 * real user monitoring (e.g. session replay). Nothing in this file will be
 * active if enable-datadog-rum flag is disabled in launchdarkly.
 */

const baVersion = global.BA_PACKAGE_VERSION || "<unknown>";

const {getFeatureFlag} = require("./FeatureFlags");

let alreadyInit = false;
let datadogRum = null;

const init = function() {
	if (alreadyInit) return;
	if (typeof window === "undefined" || process.env.IS_NODE) return;

	// Require dynamically to avoid importing inside server-side code
	datadogRum = require("@datadog/browser-rum").datadogRum;

	// We will probably only ever use RUM for production, but in the
	// off chance we enable the launchdarkly flag for Test environments,
	// we'll want to be able to differentate between our test servers
	let env = "development";
	if (document.location.hostname === "beastacademy.com") {
		env = "production";
	} else if (document.location.hostname !== "localhost") {
		env = document.location.hostname.substring(
			0,
			document.location.hostname.indexOf(".")
		);
	}

	const sessionReplaySampleRate = Number(
		getFeatureFlag("CONTROL_DATADOG_SESSION_REPLAY", 20)
	);

	datadogRum.init({
		applicationId: "d69d6f6b-4078-4c92-8dba-a1a2e0db248b",
		clientToken: "pub4537d730a6219010d3bf8b14d7e535dc",
		// see https://docs.datadoghq.com/getting_started/site/
		site: "us3.datadoghq.com",
		service: "beast-academy",
		allowedTracingUrls: [
			/^https?:\/\/beastacademy\.com/,
			/^https?:\/\/krakentest\.com/,
			/^https?:\/\/fionatest\.com/,
			/^https?:\/\/lizzietest\.com/,
			/^https?:\/\/groggtest\.com/,
			/^https?:\/\/rotetest\.com/,
			/^https?:\/\/winnietest\.com/,
			/^https?:\/\/rosencrantztest\.com/,
			/^https?:\/\/clodtest\.com/,
			/^https?:\/\/beastacademytest\.com/,
		],
		env: env,
		version: baVersion,
		sessionSampleRate: 100,
		sessionReplaySampleRate,
		defaultPrivacyLevel: "mask-user-input",
		proxy: "/datadog-proxy",
	});
	alreadyInit = true;
};

const setUser = function(user) {
	if (user && user.platformUserID) {
		datadogRum?.setUser({
			id: user.platformUserID,
			name: user.model?.username,
		});
	}
};

module.exports = {
	init,
	setUser,
};
